import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchFormsList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/forms', {
            params: queryParams,
            headers: {
              WithoutSchoolFilter: true,
            }
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
